<template>
    <div class="body">
        <div style="margin-bottom: 3rem;">
            <div style="text-align: center; font-size: 2rem; font-weight: bold; margin-bottom: 1rem;">
                会员充值
            </div>

            <div style="font-weight: bold;">请输入充值账号：</div>
            <van-field v-model="query.uid" placeholder="注意，账号输错无法退款" clearable/>

            <div style="margin: 1rem 0;">
                <div style="font-weight: bold;">请选择要充值的会员类别及会员：</div>
                <van-tabs>
                    <van-tab v-for="item in goodsClassList" :key="item">
                        <div slot="title" @click="clickTab(item)">{{goodsClassMap[item].name}}</div>
                        <van-row>
                            <van-col span="12" v-for="item2 in goodsClassMap[query.goodsClass].goodsList"
                                     style="margin-top: 1rem; padding: 0 0.5rem;">
                                <van-button plain hairline type="warning" @click="vipRecharge(item2)"
                                            style="height: 8rem;">
                                    <div style="line-height: 2rem;">
                                        {{item2.name}}
                                    </div>
                                    <div style="line-height: 2rem;">
                                        原价：{{item2.facePrice}}
                                    </div>
                                    <div style="line-height: 2rem;">
                                        现价：{{item2.itemPrice}}
                                    </div>
                                </van-button>
                            </van-col>
                        </van-row>

                        <div style="margin-top: 2rem;">
                            <div v-for="item3 in goodsClassMap[item].desc.split('\n')">
                                {{item3}}
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import wxpayAPI from '@/api/wxpay';

    export default {
        data() {
            return {
                goodsClassList: ["YOUKU", "TX", "MGTV", "AQY"],
                goodsClassMap: {
                    "YOUKU": {
                        name: "优酷土豆",
                        desc: "使用须知\n" +
                        "1、输入手机号，点击支付即可。\n" +
                        "2、优酷黄金会员不支持电视端，请谨慎购买。\n" +
                        "3、会员充值属虚拟商品，充值前请仔细核对，充值成功后，本服务不支持撤销、退货、退款。",
                        goodsList: [
                            {
                                id: "20859",
                                name: "优酷土豆黄金会员（周卡）",
                                facePrice: 9,
                                itemPrice: 5.4,
                            },
                            {
                                id: "20275",
                                name: "优酷土豆黄金会员（月卡）",
                                facePrice: 20,
                                itemPrice: 12,
                            },
                            {
                                id: "20277",
                                name: "优酷土豆黄金会员（年卡）",
                                facePrice: 198,
                                itemPrice: 138.6,
                            },
                            {
                                id: "20276",
                                name: "优酷土豆黄金会员（季卡）",
                                facePrice: 56,
                                itemPrice: 39.2,
                            },
                        ]
                    },
                    "TX": {
                        name: "腾讯视频",
                        desc: "使用须知\n" +
                        "1、输入QQ号，点击支付即可，不支持手机号、微信号充\n" +
                        "2、腾讯视频会员不支持电视端，腾讯云视听支持电视、手机、电脑、ipad端使用，请谨慎购买。\n" +
                        "3、会员充值属虚拟商品，充值前请仔细核对，充值成功后，本服务不支持撤销、退货、退款。",
                        goodsList: [
                            {
                                id: "20860",
                                name: "腾讯视频VIP（周卡）",
                                facePrice: 10,
                                itemPrice: 6,
                            },
                            {
                                id: "20272",
                                name: "腾讯视频VIP（月卡）",
                                facePrice: 20,
                                itemPrice: 14,
                            },
                            {
                                id: "20274",
                                name: "腾讯视频VIP（年卡）",
                                facePrice: 198,
                                itemPrice: 138.6,
                            },
                            {
                                id: "20273",
                                name: "腾讯视频VIP（季卡）",
                                facePrice: 58,
                                itemPrice: 40.6,
                            },
                        ]
                    },
                    "MGTV": {
                        name: "芒果TV",
                        desc: "使用须知\n" +
                        "1、输入手机号，点击支付即可。\n" +
                        "2、PC移动影视会员不支持电视端使用，全屏影视会员支持电视端使用，请谨慎购买。\n" +
                        "3、会员充值属虚拟商品，充值前请仔细核对，充值成功后，本服务不支持撤销、退货、退款。",
                        goodsList: [
                            {
                                id: "20858",
                                name: "芒果TV移动PC端会员（周卡）",
                                facePrice: 9,
                                itemPrice: 4.5,
                            },
                            {
                                id: "20278",
                                name: "芒果TV移动PC端会员（月卡）",
                                facePrice: 20,
                                itemPrice: 10,
                            },
                            {
                                id: "20279",
                                name: "芒果TV移动PC端会员（季卡）",
                                facePrice: 55,
                                itemPrice: 27.5,
                            },
                            {
                                id: "20280",
                                name: "芒果TV移动PC端会员（年卡）",
                                facePrice: 198,
                                itemPrice: 99,
                            },
                        ]
                    },
                    "AQY": {
                        name: "爱奇艺",
                        desc: "使用须知\n" +
                        "1.仅支持手机号充值，输入手机号，点击支付即可。\n" +
                        "2.会员充值属虚拟商品，充值前请仔细核对，充值成功后，本服务不支持撤销、退货、退款。\n" +
                        "3.如有质量问题，请于有效期前联系客服，过期即作废,非质量问题无法退换，不同意勿拍。\n" +
                        "4.爱奇艺黄金会员适用手机、电脑、ipad, 不支持电视端，请谨慎购买。",
                        goodsList: [
                            {
                                id: "20813",
                                name: "爱奇艺黄金会员（周卡）",
                                facePrice: 10,
                                itemPrice: 6,
                            },
                            {
                                id: "20269",
                                name: "爱奇艺黄金会员（月卡）",
                                facePrice: 19.8,
                                itemPrice: 13.86,
                            },
                            {
                                id: "20271",
                                name: "爱奇艺黄金会员（年卡）",
                                facePrice: 198,
                                itemPrice: 138.6,
                            },
                            {
                                id: "20270",
                                name: "爱奇艺黄金会员（季卡）",
                                facePrice: 58,
                                itemPrice: 40.6,
                            },
                        ]
                    },
                },
                query: {
                    traderId: this.$route.query.traderId,
                    openId: this.$route.query.openId,
                    goodsId: "",
                    goodsName: "",
                    goodsClass: "YOUKU",
                    uid: "",
                },
            }
        },
        methods: {
            clickTab(key) {
                this.query.goodsClass = key;
            },
            vipRecharge(item2) {
                if (!this.query.traderId || !this.query.openId) {
                    this.$toast("页面链接有误，请重新获取链接");
                    return;
                }
                if (!this.query.uid) {
                    this.$toast("请先填写账号");
                    return;
                }
                this.query.goodsId = item2.id;
                this.query.goodsName = item2.name;
                this.$toast.loading({forbidClick: true});
                wxpayAPI.vipRecharge(this.query).then((result) => {
                    this.$toast.clear();
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(result.data), false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(result.data));
                            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(result.data));
                        }
                    } else {
                        this.onBridgeReady(result.data);
                    }
                }).catch(() => {
                });
            },
            onBridgeReady(data) {
                // 根据返回参数跳转微信支付页面
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                        "appId": data.appId,          //公众号名称，由商户传入
                        "timeStamp": data.timeStamp,  //时间戳，自1970年以来的秒数
                        "nonceStr": data.nonceStr,    //随机串
                        "package": data.package,      //订单详情扩展字符串
                        "signType": data.signType,    //微信签名方式：
                        "paySign": data.paySign,      //微信签名
                    },
                    function (res) {
                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                            // 使用以上方式判断前端返回,微信团队郑重提示：
                            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        }
                    }
                );
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .body {
        padding: 2rem 2rem;
        line-height: 2.5rem;
        p {
            text-align: center;
            color: #000000;
        }
        img {
            height: 25rem;
            width: 18rem;
        }

    }

</style>
